import React from 'react';
import moment from 'moment';
import { Tag, Tooltip } from 'antd';
import { MoreMenu, MoreTags } from 'datastake-daf/dist/components';

export const renderEventStatusTag = ({ value, t = (s) => s }) => {
  const width = 87;

  switch (value) {
    case 'edited':
      return (
        <Tag color="orange" style={{ width }} className="text-center">
          {t('Edited')}
        </Tag>
      );
    case 'submitted':
      return (
        <Tag color="green" style={{ width }} className="text-center">
          {t('Submitted')}
        </Tag>
      );
    default:
      return (
        <Tag color="blue" style={{ width }} className="text-center">
          {t('Private')}
        </Tag>
      );
  }
}

const cols = (t, module = 'pme', view, show = 'show', activeFilters = {}, push, activeTab = 'ownData') => {
  const cols = [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'datastakeId',
      show: true,
      ellipsis: true,
      defaultSortOrder: activeFilters.sortBy === 'datastakeId' ? activeFilters.sortDir : undefined,
      sorter: () => 0 + 0,
      width: 160,
      testimonials: true,
      render: (v, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        return (
          <div className="daf-default-cell">
            {v}
          </div>
        );
      }
    },
    {
      title: t('Title'),
      dataIndex: 'eventTitle',
      key: 'eventTitle',
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      testimonials: true,
      ellipsis: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'eventTitle' ? activeFilters.sortDir : undefined,
      show: true,
    },
    {
      title: t('Type'),
      dataIndex: 'typeOfEvent',
      key: 'typeOfEvent',
      sorter: (a, b) => ('' + a.typeOfEvent).localeCompare(b.typeOfEvent),
      show: true,
      testimonials: true,
      onlyEvents: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Date'),
      dataIndex: 'dateOfEvent',
      key: 'dateOfEvent',
      testimonials: true,
      show: true,
      sorter: () => 0 + 0,
      defaultSortOrder: activeFilters.sortBy === 'dateOfEvent' ? activeFilters.sortDir : undefined,
      searchType: 'date',
      width: 125,
      render: (date, all) => {
        const title = date ? moment(date).format('DD MMM YYYY') : '';
        return <Tooltip title={title}>{title}</Tooltip>
      },
      ellipsis: true,
    },
    {
      title: t('Location'),
      dataIndex: 'location',
      key: 'location',
      show: true,
      testimonials: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Province'),
      dataIndex: 'province',
      key: 'province',
      show: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Territory'),
      dataIndex: 'territory',
      key: 'territory',
      show: true,
      render: (title) => <Tooltip title={title}>{title}</Tooltip>,
      ellipsis: true,
    },
    {
      title: t('Category'),
      dataIndex: 'category',
      className: 'event-category-col',
      key: 'category',
      show: true,
      width: 190,
      search: true,
      searchType: 'dropdown',
      render: (category, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        if (!category) {
          return '--';
        }

        return <MoreTags values={[{ label: category, key: category }]} />
      },
    },
    {
      title: t(activeTab === 'ownData' ? 'Source' : 'Initial Source'),
      dataIndex: 'testimonialsSource',
      key: 'testimonialsSource',
      testimonials: true,
      render: (value, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        const val = (value || []).map((v, i) => ({ label: v.name, value: `${v.name}-${i}` }));

        return val.length ? <MoreTags values={val} /> : '--';
      },
      ellipsis: true,
    },
    {
      title: t(activeTab !== 'ownData' ? 'Source' : 'Status'),
      dataIndex: activeTab !== 'ownData' ? 'source' : 'status',
      key: activeTab !== 'ownData' ? 'source' : 'status',
      show: true,
      testimonials: true,
      width: 120,
      render: (value, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        if (activeTab !== 'ownData') {
          return value;
        }

        return renderEventStatusTag({ value, t })
      },
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'actions',
      width: 60,
      testimonials: true,
      show: true,
      key: 'actions',
      render: (_, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        const redView = view ? view !== 'events' ? view : 'event' : 'event';
        return (
          <MoreMenu
            items={[{
              label: t('Details'),
              onClick: () => push(`/app/${module}/view/${redView}/${val.id}`),
              key: "view",
            }]}
          />
        );
      }
    }

    // {
    //   title: t('Risk Category'),
    //   dataIndex: 'associatedRisk',
    //   key: 'associatedRisk',
    //   show: true,
    //   className: 'd-none',
    //   render: category => {
    //     return category ? (
    //       <>
    //         {(Array.isArray(category) ? category : []).map((c, i) => {
    //           return (
    //             <Tag key={i}>
    //               {c}
    //             </Tag>
    //           )
    //         })}
    //       </>
    //     ) : null
    //   },
    //   search: true,
    //   searchType: 'dropdown',
    // },
  ];

  if (view === 'events') {
    return cols.filter(c => c[show]);
  }

  if (view === 'testimonials') {
    return cols.filter(c => c.testimonials);
  }

  return cols.filter(c => c[show] && !c.onlyEvents);
}

export default cols;
